import {Placement, Coords} from '@floating-ui/dom';

export function applyTooltipArrowPositionStyle(arrowElement: HTMLElement, tooltipPlacement: Placement, arrowCoords: Coords, offset: string): void {
    const {x: arrowX, y: arrowY} = arrowCoords;

    const staticSide = (
        {
            top: 'bottom',
            right: 'left',
            bottom: 'top',
            left: 'right',
        } as any
    )[tooltipPlacement.split('-')[0]];

    Object.assign(arrowElement.style, {
        left: arrowX != null ? `${arrowX}px` : '',
        top: arrowY != null ? `${arrowY}px` : '',
        right: '',
        bottom: '',
        [staticSide]: offset,
    });
}
